<script lang="ts" setup>
import {PropType} from "vue";
import {useApp} from "~/store/useApp";

const opened = ref<boolean>(false)
const current = ref<string | null>(null)

const emit = defineEmits({
  change: null
})

const props = defineProps({
  options: {
    type: Object as PropType<string[]>,
    required: true
  },
  title: {
    type: String as PropType<string>,
    required: true
  },
  index: {
    type: Number as PropType<number>,
    required: true
  },
  validate: {
    type: Boolean as PropType<boolean>,
    required: false
  }
})
function selectHandle(value: string) {
  current.value = value
  opened.value = false
  emit('change', value, props.index)
}

function openHandle() {
  opened.value = !opened.value
}

const appStore = useApp()
</script>

<template>
  <div class="relative">
    <p class="pb-1 text-dark">
      {{title}}
    </p>
    <div
        :class="['w-full lg:w-[693px] h-[43px] lg:h-[53px] bg-white pt-[5px] lg:pt-[10px] pl-[14px] rounded-[5px]'+
'        cursor-pointer shadow-md', validate ? 'outline outline-2 outline-red-500' : '']"
        @click="openHandle"
    >
      <div class="w-[105px] h-[30px] relative">
        <div :class="[`w-0 h-0 absolute top-[14px]
            border-t-[8px] border-t-ui
            border-r-[8px] border-transparent
            border-b-0 border-b-transparent
            border-l-[8px] border-l-transparent`, appStore.dir === 'rtl' ? 'right-[20px]' : 'left-[6px]']">
        </div>
        <div
            :class="['absolute w-full lg:w-[590px] top-[4px] text-dark',
            appStore.dir === 'rtl' ? 'right-[50px]' : 'left-[66px]']"
            v-if="current"
        >
          {{ current }}
        </div>
      </div>

    </div>

    <div v-if="opened" class="absolute left-0 top-[70px] lg:top-[80px] rounded-[5px] shadow-md z-10">
      <div
          v-for="(value) in options"
          class="w-[304px] lg:w-[693px] h-[40px] bg-white border-t border-t-neutral-100 px-4 pt-0 cursor-pointer
          flex items-center gap-4"
          @click="selectHandle(value)"
      >
        <p class="text-dark">
          {{ value }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
